<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Equipamentos</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="card-small mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
              <d-col cols="12" lg="8" class="text-right">
              </d-col>
            </d-row>
          </d-card-header>

          <equipment-form/>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import EquipmentForm from '_modules/equipment/components/EquipmentForm.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/EquipmentModel';

export default {
  name: 'equipment-create',
  components: {
    EquipmentForm,
  },
  created() {
    Events.$emit(_LOAD_MODEL_, MODEL);
    Events.$emit('sidebarVisible', false);
  },
};
</script>

<style lang="scss" scoped>
</style>
